export const faqs = [
  [
    'Is this a physical product?',
    'No. The Complete Crochet Bag Bundle is a 100% digital collection of downloadable PDF pattern books. No physical books, finished handbags, yarn, hooks, or crafting supplies will be shipped.',
  ],
  [
    'Who is this bundle for?',
    'It is designed for people who already know how to crochet and want beautiful new handbag and accessory patterns — whether you make projects for yourself, give handmade gifts, or simply love exploring fresh designs.',
  ],
  [
    'Do I need to know how to crochet?',
    'Yes. The collection is intended for people who already understand basic crochet techniques. It is not a beginner course teaching crochet from scratch.',
  ],
  [
    'Are these complete crochet patterns or just pictures?',
    'They are complete written patterns, not just photographs or inspiration. Each project includes row-by-row or round-by-round instructions where required, stitch counts, shaping, assembly, and finishing details.',
  ],
  [
    'Do the patterns include yarn amounts, hook sizes, and measurements?',
    'Yes. Patterns specify the yarn type, approximate amount required, recommended crochet hook, additional supplies, and finished measurements in inches and centimeters. Results may vary depending on yarn, hook size, and tension.',
  ],
  [
    'Are all 50 bag patterns and 5 bonus books included?',
    'Yes. You receive the five main volumes with 50 bag designs plus five bonus books with 55 accessory projects — 105 patterns in total, at no extra charge.',
  ],
  [
    'What language are the patterns written in?',
    'The collection is written in English using US crochet terminology.',
  ],
  [
    'How do I receive my order?',
    "After your payment is completed, you'll receive access instructions through our digital delivery system and can download all 10 PDF books right away.",
  ],
  ['Is this a subscription?', 'No. This is a one-time purchase of $26.90 USD, not a monthly subscription.'],
  [
    'Is there a guarantee?',
    "Yes. Your purchase includes a 7-day guarantee, subject to the store's published purchase and refund terms.",
  ],
] as const
